import React from 'react';

function statusClass(stageOrStatus) {
    const v = (stageOrStatus || '').toLowerCase();
    if (v === 'final') return 'status-final';
    if (v.includes('draft')) return 'status-draft-1';
    if (v === 'coming soon') return 'status-coming-soon';
    if (v) return 'status-work-in-progress';
    return '';
}

export default function BookList({ series, signedIn, onSignIn, onSeriesClick }) {
    if (!series.length) {
        return (
            <div style={{ textAlign: 'center', padding: '48px 0', color: 'var(--ink-3)', fontSize: 13 }}>
                No series available.
            </div>
        );
    }

    return (
        <ul className="book-list">
            {series.map((s, i) => {
                const accentCls = 'accent-' + (s.accent || 'sky');
                const books = s.books || [];
                const stage = s.status || s.stage || '';
                const hasLocked = !signedIn && books.some(b => b.loginRequired || b.gated);

                return (
                    <li
                        key={s.id || s.title}
                        className={`book-row ${accentCls}`}
                        onClick={() => onSeriesClick(s)}
                    >
                        <div className="book-row-num">
                            {String(i + 1).padStart(2, '0')}
                        </div>
                        <div className="book-row-main">
                            <div className="book-row-hd">
                                <h3>{s.title}</h3>
                                {stage && (
                                    <span className={'status-pill ' + statusClass(stage)}>{stage}</span>
                                )}
                                {hasLocked && (
                                    <span className="status-pill status-login-required">some locked</span>
                                )}
                            </div>
                            <div className="book-row-meta">
                                {s.genre} · {s.count ?? books.length}&nbsp;
                                {(s.count ?? books.length) === 1 ? 'volume' : 'volumes'}
                            </div>
                            <p>{s.blurb || s.description}</p>
                        </div>
                        <div className="book-row-action">
                            <span className="link-arrow">View →</span>
                        </div>
                    </li>
                );
            })}
        </ul>
    );
}
